<main-content-holder>
  <ng-container *ngIf="!changePassMode;else changePassword">
    <h2 class="center-align" i18n="Sign In|Sign In page title@@sign-in-title">Sign In</h2>

    <div class="color-green mat-body-2 center-align" i18n="Sign In|Sign In page case-sensitive note@@sign-in-case-sensitive-note">
      (email, identifier, and password are case sensitive, so please input carefully)
    </div>

    <div fxLayout="row" fxLayout.lt-md="column" class="full-width">
      <form [fxFlex]="allowSocialSignIn ? '48%' : '98%'" [formGroup]="signInForm" class="center-align">
        <form-input [control]="identifierField"
                    label="Email or username"
                    i18n-label="Sign In|Email or username input label@@sign-in-email-or-username-label"
                    placeholder="Your email or username..."
                    i18n-placeholder="Sign In|Email or username input placeholder@@sign-in-email-or-username-placeholder"
                    autocomplete="email"
                    type="text"
                    [minLength]="5" [maxLength]="128"
                    suffixIcon="perm_identity"
                    suffixTooltip="Sign In with your QuizWin account.&#13;It provides you with access to a group of supported competitions."
                    i18n-suffixTooltip="Sign In|Email input account help tooltip@@sign-in-email-account-help-tooltip"
                    (focusLost)="handleUsernameChange()"></form-input>

        <div *ngIf="checkedUser" class="checked-user-holder">
          <div *ngIf="invitationCanBeRequested" class="center-align">
            <div class="color-orange"
              i18n="Sign Up|Sign Up invitation can be requested notification@@sign-up-invitation-can-be-requested-notification">
              Your profile was found, but the invitation was not accepted yet. You could request a new invitation if you did not receive a previous one.
            </div>

            <app-button *ngIf="invitationCanBeRequested"
                        label="Request New Invitation" #requestInvitationBtn
                        i18n-label="Sign Up|Request New Invitation button label@@sign-up-request-new-invitation-btn-label"
                        class="center request-invitation-btn"
                        [disabled]="invitationRequested || inProgress || !identifierField.valid"
                        (clicked)="requestInvitation(requestInvitationBtn);"></app-button>

            <div *ngIf="invitationRequestDetails" class="mat-body-strong">{{invitationRequestDetails}}</div>
          </div>

          <div *ngIf="checkedUser?.status == 'RESET_REQUIRED'"
               class="color-orange"
               i18n="Sign Up|Sign Up invitation user incorrect state (reset_required) notification@@sign-up-invitation-user-incorrect-state-reset_required-notification">
            A user profile was found, and it is in the middle of the password reset process. Finish your password reset
            process to access your account.
          </div>
        </div>

        <form-input [control]="passwordField"
                    label="Password"
                    i18n-label="Sign In|Password input label@@sign-in-password-label"
                    type="password"
                    suffixButton="visibility"
                    suffixButtonAlt="visibility_off"></form-input>

        <div class="progress-block">
          <app-button *ngIf="!inProgress"
                      label="Sign In"
                      i18n-label="Sign In|Sign In button label@@sign-in-btn-label"
                      class="center sign-in-btn"
                      width="205px"
                      [disabled]="shouldDisableSubmit()"
                      (clicked)="signIn()"></app-button>
          <mat-spinner *ngIf="inProgress" color="primary" class="center" [diameter]="40"></mat-spinner>
        </div>
      </form>

      <div *ngIf="allowSocialSignIn" fxHide.lt-md="true" class="or-divider">
        <mat-divider [vertical]="true" class="divider"></mat-divider>
        <span class="or text-disabled-color"
              i18n="Sign In|Sign In section divider (vertical)@@sign-in-section-divider-v-or">or</span>
        <mat-divider [vertical]="true" class="divider"></mat-divider>
      </div>

      <div *ngIf="allowSocialSignIn" fxHide.gt-sm="true" class="or-divider horizontal">
        <mat-divider class="fill-space"></mat-divider>
        <span class="or text-disabled-color"
              i18n="Sign In|Sign In section divider (horizontal)@@sign-in-section-divider-h-or">or</span>
        <mat-divider class="fill-space"></mat-divider>
      </div>

      <div *ngIf="allowSocialSignIn" fxFlex="48%" [ngClass.lt-md]="{'center': true}">
        <social-sign-in [disabled]="inProgress"
                        (progress)="inProgress = $event"
                        class="social-sign-in" [ngClass.lt-md]="{'horizontal': true}"></social-sign-in>
      </div>
    </div>
  </ng-container>

  <ng-template #changePassword>
    <h2 class="center-align" i18n="Sign In|Password change title@@sign-in-password-change-title">Change Password</h2>

    <div fxLayout="row" fxLayout.lt-md="column" class="full-width">
      <form [formGroup]="changePassConfirmForm" class="center-align" autocomplete="off">
        <form-input [control]="newPasswordField"
                    label="Password"
                    i18n-label="Sign Up|Password input label@@sign-up-password-label"
                    placeholder="New password..."
                    i18n-placeholder="Change Password|New password input placeholder@@change-password-new-password-placeholder"
                    type="password"
                    suffixButton="visibility"
                    suffixButtonAlt="visibility_off"></form-input>
        <form-input [control]="confirmPassField"
                    [formGroup]="changePassConfirmForm"
                    [errorStateMatcher]="matcher"
                    label="Confirm Password"
                    i18n-label="Change Password|Confirm password input label@@change-password-confirm-password-label"
                    placeholder="Confirm password..."
                    i18n-placeholder="Change Password|Confirm password input placeholder@@change-password-confirm-password-placeholder"
                    type="password"
                    suffixButton="visibility"
                    suffixButtonAlt="visibility_off"></form-input>

        <div class="progress-block">
          <app-button *ngIf="!inProgress"
                      label="Change Password"
                      i18n-label="Password Reset Confirm|Change button label@@password-reset-change-button-label"
                      class="cta-btn center"
                      width="205px"
                      [disabled]="shouldDisableChangePassSubmit()"
                      (clicked)="changePasswordProceed()"></app-button>
          <mat-spinner *ngIf="inProgress" color="primary" class="center" [diameter]="40"></mat-spinner>
        </div>
      </form>
    </div>
  </ng-template>

  <div class="footer center-align">
    <ng-container i18n="Sign In|Sign up proposition@@sign-in-footer-sign-up">Not with us yet?</ng-container>
    <app-link [routerLink]="studentSignUpUrl" class="nav-url"
              label="Student"
              i18n-label="General|Role Student title@@general-role-student-title"></app-link>
    <span class="sign-up-options-divider">|</span>
    <app-link [routerLink]="teacherSignUpUrl" class="nav-url"
              label="Teacher"
              i18n-label="General|Role Teacher title@@general-role-teacher-title"></app-link>
  </div>
  <div class="footer center-align">
    <app-link [routerLink]="passResetUrl" class="nav-url" label="Forgot password?"
              i18n-label="Sign In|Forgot password URL label@@sign-in-footer-forgot-pass-link-label"></app-link>
    <span class="sign-up-options-divider">|</span>
    <app-link [routerLink]="inviteRequestUrl" class="nav-url" label="No invitation?"
              i18n-label="Sign In|No invitation URL label@@sign-in-footer-no-invitation-link-label"></app-link>
  </div>

  <div class="footer center-align">
    <ng-container i18n="Sign In|Organize contest prompt@@sign-in-footer-organize-prompt">Want to organize your
      contest?
    </ng-container>
    <app-link [href]="organizeInfoUrl" class="nav-url" [external]="true" label="Learn how"
              i18n-label="Sign In|Organize contest prompt URL label@@sign-in-footer-organize-contest-prompt-link-label"></app-link>
  </div>

  <div class="footer center-align">
    <app-link [href]="supportUrl" class="nav-url" label="Support"
              i18n-label="Navigation|Support title@@navigation-support-title"></app-link>
  </div>

  <div class="language-switch">
    <language-switch theme="dark"></language-switch>
  </div>
</main-content-holder>
